import { styled } from "styled-components";

const Input = styled.input`
  width: ${(props) => props.$width || "324px"};
  height: 35px;
  border-radius: 2px;
  border: 1px solid var(--admin-gray-stroke, #e8e8e8);
  background: var(--white, #fff);
  padding: 2px 12px;
  font-family: "Noto Sans KR";
  font-size: 15px;
  font-weight: 400;
  line-height: 140%;

  &:focus {
    outline: none;
  }

  &::placeholder {
    opacity: 0.2;
  }
`;

/**
 * 조건 검색의 키워드 입력창. 검색은 검색 버튼으로만 수행하므로
 * 입력값은 부모로 즉시 전파하고, 자동 검색/디바운스는 두지 않는다.
 *
 * @param value    입력값
 * @param onChange (event) => void
 * @param placeholder 기본 "검색어 입력"
 * @param width    CSS width (기본 324px)
 */
export function KeywordInput({
  value,
  onChange,
  placeholder = "검색어 입력",
  width,
  ...rest
}) {
  return (
    <Input
      $width={width}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      {...rest}
    />
  );
}

export default KeywordInput;
